import { defineComponent, createVNode, render, reactive, ref } from 'vue'
import { darkTheme, NConfigProvider, NModal, NCard, NButton, NForm, NFormItem } from 'naive-ui'
import DynamicRender from '@/components/DynamicRender'
import './index.scss'

const FormDialogComp = defineComponent({
  props: {
    option: { type: Object }
  },
  components: {
    NConfigProvider,
    NModal,
    NCard,
    NButton,
    NForm,
    NFormItem,
    DynamicRender
  },
  setup(props, ctx) {
    const formRef = ref(null)
    const state = reactive({
      showModal: false,
      formModel: {},
      cardBodyStyle: {
        width: '600px'
      }
    })
    const methods = {
      openDialog(option) {
        state.showModal = true
        state.option = option
        state.formModel = { ...state.formModel, ...option.formModel }
      },
      closeDialog() {
        state.showModal = false
      },
      submitEditData() {
        const { onConfirm, formRules } = state.option
        if (formRules) {
          formRef.value?.validate((errors) => {
            if (!errors) {
              onConfirm && onConfirm(state.formModel)
              methods.closeDialog()
              return false
            }
          })
        } else {
          onConfirm && onConfirm(state.formModel)
          methods.closeDialog()
        }
      }
    }
    ctx.expose({ openDialog: methods.openDialog })

    return () => {
      if (!state.option) return false
      const { formFields, formRules = {} } = state.option
      return (
        <n-config-provider theme={darkTheme}>
          <n-modal v-model={[state.showModal, 'show']}>
            <n-card
              title={state.option.title}
              closable
              bordered={false}
              style={state.cardBodyStyle}
              onClose={methods.closeDialog}
            >
              {{
                default: () => (
                  <>
                    <div class="form-dialog-body">
                      <n-form
                        model={state.formModel}
                        rules={formRules}
                        label-placement="left"
                        label-width={100}
                        ref={formRef}
                      >
                        {formFields &&
                          formFields.map((field) => (
                            <n-form-item label={field.label} path={field.key}>
                              <DynamicRender field={field} v-model={state.formModel[field.key]} />
                            </n-form-item>
                          ))}
                      </n-form>
                    </div>
                  </>
                ),
                footer: () => (
                  <div class="form-modal-footer">
                    <n-button class="action-btn" size="small" onClick={methods.closeDialog}>
                      取 消
                    </n-button>
                    <n-button
                      class="action-btn"
                      size="small"
                      type="primary"
                      onClick={methods.submitEditData}
                    >
                      确 定
                    </n-button>
                  </div>
                )
              }}
            </n-card>
          </n-modal>
        </n-config-provider>
      )
    }
  }
})

let vm
const $FormDialogServer = (option) => {
  if (!vm) {
    const el = document.createElement('div')
    vm = createVNode(FormDialogComp, { option })
    render(vm, el)
    document.body.appendChild(el)
  }
  const { openDialog } = vm.component.exposed
  openDialog(option)
}

export default $FormDialogServer
